import { render, staticRenderFns } from "./TheFavoritesHeading.vue?vue&type=template&id=7eedb282&"
import script from "./TheFavoritesHeading.vue?vue&type=script&lang=js&"
export * from "./TheFavoritesHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports